import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faThLarge,
  faSitemap,
  faLaptopCode,
  faInfo,
  faCertificate,
  faLock,
  faCalendarAlt,
  faPowerOff,
  faAddressCard,
  faUsers,
  faThumbsUp,
  faChartPie,
  faUserTag,
  faPlus,
  faLink,
  faBolt,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";

export const admin_nav = [
  {
    key: "home",
    name: "Home",
    location: "/welcome/",
    icon: faHome,
    css: "leftmenu-root",
    css_active: "leftmenu-root--active",
  },
  {
    key: "interfaces",
    name: "Interfaces",
    location: "/interfaces/",
    icon: faThLarge,
    css: "leftmenu-root",
    scope: "int:mgt",
    css_active: "leftmenu-root--active",
    children: [
      {
        type: "section_header",
        name: "Interfaces",
      },
      {
        type: "section_link",
        key: "org-general",
        name: "All Interfaces",
        location: "/interfaces/",
        icon: faThLarge,
        scope: "int:mgt",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "org-general",
        name: "Create Interface",
        location: "/interfaces/create/",
        icon: faPlus,
        scope: "int:create",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_header",
        name: "Interface",
        dependant_regex: '^\/interfaces\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        dependant_variable: ':interface_id'
      },
      {
        type: "section_link",
        key: "interface-general",
        name: "General Information",
        dependancy: ':interface_id',
        location: "/interfaces/:interface_id/view/",
        icon: faInfo,
        scope: "int:view",
        css: "leftmenu-root",
        dependant_regex: '^\/interfaces\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "interface-aisp",
        name: "Account Access",
        dependancy: ':interface_id',
        location: "/interfaces/:interface_id/account/",
        icon: faLink,
        scope: "int-aisp-endpoint:list",
        css: "leftmenu-root",
        dependant_regex: '^\/interfaces\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "interface-pisp",
        name: "Payment Initiation",
        dependancy: ':interface_id',
        location: "/interfaces/:interface_id/payment/",
        icon: faDollarSign,
        scope: "int-pisp:view",
        css: "leftmenu-root",
        dependant_regex: '^\/interfaces\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "interface-integrate",
        name: "Integration",
        dependancy: ':interface_id',
        location: "/interfaces/:interface_id/integrate/",
        icon: faBolt,
        css: "leftmenu-root",
        scope: "int-integration:view",
        dependant_regex: '^\/interfaces\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "interface-security",
        name: "Security",
        dependancy: ':interface_id',
        location: "/interfaces/:interface_id/security/",
        icon: faLock,
        scope: "int-security:view",
        css: "leftmenu-root",
        dependant_regex: '^\/interfaces\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      }
    ],
  },
  {
    key: "organisation",
    name: "Organisation",
    location: "/organisation/",
    icon: faSitemap,
    scope: "org:mgt",
    css: "leftmenu-root",
    css_active: "leftmenu-root--active",
    children: [
      {
        type: "section_header",
        name: "ORGANISATION",
        scope: "org:mgt",
      },
      {
        type: "section_link",
        key: "org-general",
        name: "General Information",
        location: "/organisation/info/",
        icon: faInfo,
        scope: "org:mgt",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_header",
        name: "Security",
        scope: "org-credentials:view",
      },
      {
        type: "section_link",
        key: "orgcc",
        name: "Client Credentials",
        location: "/organisation/credentials/",
        icon: faLock,
        scope: "org-credentials:view",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "testff",
        name: "Certificates",
        location: "/organisation/certificates/",
        icon: faCertificate,
        scope: "org-cert:list",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_header",
        name: "User Management",
        scope: "org-user:list",
      },
      {
        type: "section_link",
        key: "users",
        name: "Users",
        location: "/organisation/users/",
        icon: faUsers,
        scope: "org-user:list",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "certificates",
        name: "Roles & Policies",
        location: "/organisation/roles/",
        icon: faUserTag,
        scope: "org-roles:list",
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      }
    ],
  },
  {
    key: "tpp-manager",
    name: "TPP Manager",
    location: "/tpp/",
    scope: "tpp:mgt",
    icon: faAddressCard,
    css: "leftmenu-root",
    css_active: "leftmenu-root--active",
    children: [
      {
        type: "section_header",
        name: "TPPs",
        scope: "tpp-all:mgt",
      },
      {
        type: "section_link",
        key: "tppManager",
        name: "All Registered TPPs",
        location: "/tpp/",
        scope: "tpp-all:mgt",
        icon: faAddressCard,
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_header",
        name: "TPP",
        scope: "tpp-general:mgt",
        dependant_regex: '^\/tpp\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        dependant_variable: ':interface_id'
      },
      {
        type: "section_link",
        key: "tpp_general",
        name: "General Information",
        scope: "tpp-general:mgt",
        dependancy: ':tpp_id',
        location: "/tpp/:tpp_id/view/",
        icon: faInfo,
        css: "leftmenu-root",
        dependant_regex: '^\/tpp\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "tpp_apps",
        name: "Registered Apps",
        scope: "tpp-apps:mgt",
        dependancy: ':tpp_id',
        location: "/tpp/:tpp_id/apps/",
        icon: faThLarge,
        css: "leftmenu-root",
        dependant_regex: '^\/tpp\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "tpp_app_certs",
        name: "Secure Certificates",
        scope: "tpp-certs:mgt",
        dependancy: ':tpp_id',
        location: "/tpp/:tpp_id/certificates/",
        icon: faCertificate,
        css: "leftmenu-root",
        dependant_regex: '^\/tpp\/[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-4[0-9A-Fa-f]{3}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}\/[^\/]*\/',
        css_active: "leftmenu-root--active",
      },]
  },
  {
    key: "test-centre",
    name: "Test Centre",
    scope: "test:mgt",    
    location: "/test-centre/",
    icon: faLaptopCode,
    css: "leftmenu-root",
    css_active: "leftmenu-root--active",
    children: [
      {
        type: "section_header",
        name: "Consent Manager",
        scope: "test-consent:mgt", 
      },
      {
        type: "section_link",
        key: "consent",
        name: "Consent Manager",
        scope: "test-consent:mgt", 
        location: "/test-centre/consent/",
        icon: faThumbsUp,
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_header",
        name: "Test Management",
        scope: "test-mngr:mgt", 
      },
      {
        type: "section_link",
        key: "test-manager",
        name: "Test Manager",
        scope: "test-mngr:mgt", 
        location: "/test-centre/test-manager/",
        icon: faLaptopCode,
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_link",
        key: "automator",
        name: "Automation",
        scope: "test-auto:mgt", 
        location: "/test-centre/automator/",
        icon: faCalendarAlt,
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
      {
        type: "section_header",
        name: "Reporting",
        scope: "test-reports:mgt", 
      },
      {
        type: "section_link",
        key: "reports-statistics",
        name: "Reports & Statistics",
        scope: "test-reports:mgt", 
        location: "/test-centre/reports-statistics/",
        icon: faChartPie,
        css: "leftmenu-root",
        css_active: "leftmenu-root--active",
      },
    ],
  },
];
